// 🎲 distributeModels — assign AI models to a randomized cast WITHOUT
// duplicates by default (Nina 08-28). Extracted from CustomSpace.js so it can
// be unit-tested (utils/distributeModels.test.js).
//
// WHY no-duplicate: the old version drew independently WITH replacement, so a
// small cast routinely got two of the same model — the "2 llamas in the 90s
// cafe" (independent draws duplicate ~52% of 3-AI casts from a 5-model pool).
// Two identical low-tier models don't just each repeat, they converge to the
// same flat register (character-depth arc). Drawing without replacement is
// cost-neutral (same pool) and buys voice + provider variety, which matters
// more than raw model tier.
//
// Shape (unchanged): returns a histogram { [modelName]: seatCount } summing to
// `count`. Only models in `pool` are assigned; `names` seeds the zero counts
// so every selectable model appears as a key (downstream reads Object.values).
// Manual per-model picks in the builder bypass this entirely.

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function distributeModels(count, names = [], pool = []) {
  const counts = Object.fromEntries((names || []).map((m) => [m, 0]));
  if (!Array.isArray(pool) || pool.length === 0 || count <= 0) return counts;
  // Fill from a shuffled bag; when the cast is larger than the pool the bag
  // reshuffles and repeats spread as evenly as a fresh shuffle allows.
  let bag = [];
  for (let i = 0; i < count; i += 1) {
    if (bag.length === 0) bag = shuffle(pool);
    const model = bag.pop();
    counts[model] = (counts[model] || 0) + 1;
  }
  return counts;
}

export default distributeModels;
